var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8.5H7.2A7.2 7.2 0 0 0 0 7.7v21.6a7.2 7.2 0 0 0 7.2 7.2h21.6a7.2 7.2 0 0 0 7.2-7.2V7.7A7.2 7.2 0 0 0 28.8.5Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.499 15.688-2.35 5.601H5.44l.506-1.21h2.28l.506 1.21h1.292l-2.35-5.602H6.499Zm.591 1.667.677 1.626H6.405l.685-1.627ZM20.414 15.688v5.601h4.19v-1.114H21.7v-4.488h-1.285ZM30.46 15.688l-1.244 2.083-1.243-2.084H26.58l1.993 3.39v2.212h1.285v-2.212l1.992-3.39H30.46ZM14.91 19.103h.322c.33 0 .653.273.653.605v.02c0 .333-.323.605-.653.605H13.9v-1.23h1.01Zm.004-2.45h.117c.33 0 .6.272.6.605v.02c0 .332-.27.605-.6.605H13.9v-1.23h1.014ZM12.6 21.29h3.23c.749 0 1.36-.615 1.36-1.37v-.22c0-.655-.46-1.205-1.069-1.34l-.011-.004.071-.02c.803-.261.72-1.232.72-1.232 0-.756-.695-1.376-1.438-1.404l-1.384-.004h-1.48v5.594Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9225cb23458bcef5c8020d6349f2f569.svg";
export { ForwardRef as ReactComponent };